import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";

/* אנימציית fade+slide עדינה (כניסה) */
const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/* מעטפת חצי-שקופה קבועה שאינה נעלמת */
const Container = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  padding: 40px;
  backdrop-filter: blur(18px);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  color: white;
  font-family: "Assistant", sans-serif;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

/* מעטפת לתוכן המתחלף */
const Slide = styled.div`
  animation: ${fadeSlideIn} 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  display: flex;
  flex-direction: ${(props) => (props.orientation === "landscape" ? "row" : "column")};
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

/* אזור טקסט */
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${(props) => (props.orientation === "landscape" ? "1" : "unset")};
  align-items: ${(props) => (props.orientation === "landscape" ? "flex-end" : "center")};
  text-align: ${(props) => (props.orientation === "landscape" ? "right" : "center")};
  margin-left: ${(props) => (props.orientation === "landscape" ? "20px" : "0")};
  margin-right: ${(props) => (props.orientation === "landscape" ? "10px" : "0")};
`;

const Title = styled.h3`
  margin: ${(props) =>
    props.orientation === "landscape" ? "4px 0 0px 0px" : "0px 0 0px 0px"};

  font-size: ${(props) =>
    props.orientation === "landscape" ? "2rem" : "3rem"};
`;

const Text = styled.p`
  font-size: ${(props) => props.orientation === "portrait" ? "1.8rem" : "1.2rem"};
  margin: ${(props) => props.orientation === "portrait" ? "20px 0px 0px 0px" : "0px 0px 0px 0px"};
`;

/* תמונה */
const Image = styled.img`
  border-radius: 10px;
  object-fit: contain;
  flex-shrink: 0;

  max-width: ${(props) => (props.orientation === "portrait" ? "70%" : "22%")};
  max-height: ${(props) => (props.orientation === "portrait" ? "70%" : "35%")};

  margin-top: ${(props) => (props.orientation === "portrait" ? "20px" : "0")};
  margin-left: ${(props) => (props.orientation === "landscape" ? "10px" : "0")};
`;

const DidYouKnowSlider = ({  items = [],
  interval = 10000,
  orientation = "portrait" }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!items || items.length === 0) return;
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, interval);

    return () => clearInterval(timer);
  }, [items, interval]);

  if (!items || items.length === 0) {
    return (
      <Container>
        <Text>אין מידע להצגה</Text>
      </Container>
    );
  }

  const currentItem = items[index];

  return (
    <Container>
      <Slide key={index} orientation={orientation}>
        <TextWrapper orientation={orientation}>
          <Title orientation={orientation}>{currentItem.title}</Title>
          <Text orientation={orientation}>{currentItem.text}</Text>
        </TextWrapper>

        {currentItem.image && (
          <Image
            src={currentItem.image}
            alt={currentItem.title}
            orientation={orientation}
          />
        )}
      </Slide>
    </Container>
  );
};

DidYouKnowSlider.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      image: PropTypes.string,
    })
  ),
  interval: PropTypes.number,
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
};

export default DidYouKnowSlider;
